import { useEffect } from "react"

function getScrollbarWidth() {
  const outer = document.createElement("div")
  outer.style.visibility = "hidden"
  outer.style.overflow = "scroll"
  outer.style.width = "100px"
  document.body.appendChild(outer)

  const inner = document.createElement("div")
  outer.appendChild(inner)

  const scrollbarWidth = outer.offsetWidth - inner.offsetWidth
  document.body.removeChild(outer)
  return scrollbarWidth
}

function disableScroll() {
  document.body.classList.add("no-scroll")
  document.body.style.setProperty("--scrollbar-width", `${getScrollbarWidth()}px`)
}

function enableScroll() {
  document.body.classList.remove("no-scroll")
}

export function usePreventBodyScroll(condition: boolean | undefined) {
  useEffect(() => {
    if (condition) {
      disableScroll()
    }

    return () => {
      enableScroll()
    }
  }, [condition])
}
